import './toast.css'

import type { ToastOptions } from 'react-toastify/unstyled'
import { Bounce, toast } from 'react-toastify/unstyled'

import { t } from '@/utils/i18n.util'

import { IconCheckRing, IconError, IconInfo, IconWarning } from './components/Icons'

export { ToastContainer } from 'react-toastify/unstyled'

const BASE_SETTINGS = {
  autoClose: 5000,
  closeOnClick: true,
  draggable: true,
  hideProgressBar: false,
  pauseOnHover: true,
  position: 'top-right',
  progress: undefined,
  theme: 'light',
  transition: Bounce,
} as ToastOptions

const SUCCESS_SETTINGS = {
  ...BASE_SETTINGS,
  className: 'toast-success-custom',
  bodyClassName: 'toast-success-body',
  progressClassName: 'toast-success-progress',
  icon: IconCheckRing,
} as ToastOptions

const INFO_SETTINGS = {
  ...BASE_SETTINGS,
  className: 'toast-info-custom',
  bodyClassName: 'toast-info-body',
  progressClassName: 'toast-info-progress',
  icon: IconInfo,
} as ToastOptions

const ERROR_SETTINGS = {
  ...BASE_SETTINGS,
  className: 'toast-error-custom',
  bodyClassName: 'toast-error-body',
  progressClassName: 'toast-error-progress',
  icon: IconError,
} as ToastOptions

const WARNING_SETTINGS = {
  ...BASE_SETTINGS,
  className: 'toast-warning-custom',
  bodyClassName: 'toast-warning-body',
  progressClassName: 'toast-warning-progress',
  icon: IconWarning,
} as ToastOptions

export const toastSuccess = (s: string) => toast.success(s, SUCCESS_SETTINGS)
export const toastInfo = (s: string) => toast.info(s, INFO_SETTINGS)

export const toastErr = (s?: string, toastId?: string) =>
  toast.error(s || t('error.generic_error'), toastId ? { ...ERROR_SETTINGS, toastId } : ERROR_SETTINGS)
export const toastWarn = (s: string) => toast.warning(s, WARNING_SETTINGS)
